export const SET_CHECKLIST_STATE = 'SET_CHECKLIST_STATE'
export const SET_CHECKLIST_ERROR = 'SET_CHECKLIST_ERROR'
export const SET_CHECKLIST_STEP = 'SET_CHECKLIST_STEP'
